/*
 * Takes a uid string (say Prismic document uid) and converts to a pathname
 * @param {string} uid, for e.g foo__bar
 */
export default function uidToPathname(uid) {
  return uid.replace(/(__)+/g, '/');
}
